import {
  SET_REFRESH_TIMESTAMP,
  RESET_REFRESH_TIMESTAMP,
  SET_REFRESH_DURATION,
  SILENT_REFRESH,
} from "./actionTypes";

export const actions = {
  setRefreshTimeStamp: (component) => ({
    type: SET_REFRESH_TIMESTAMP,
    payload: { component },
  }),
  resetRefreshTimeStamp: (component) => ({
    type: RESET_REFRESH_TIMESTAMP,
    payload: { component },
  }),
  setDelayDuration: (feedStaleDelayMs) => ({
    type: SET_REFRESH_DURATION,
    payload: { feedStaleDelayMs },
  }),
  silentRefresh: () => ({
    type: SILENT_REFRESH,
  }),
};

const initialState = {
  lastFeedRefreshTimestamp: null,
  feedStaleDelayMs: 1800000, // will be set by set up 3 api
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_REFRESH_TIMESTAMP: {
      const { component } = action.payload;
      return {
        ...state,
        lastFeedRefreshTimestamp: {
          ...state.lastFeedRefreshTimestamp,
          [`${component}`]: new Date(),
        },
      };
    }
    case RESET_REFRESH_TIMESTAMP: {
      const { component } = action.payload;
      return {
        ...state,
        lastFeedRefreshTimestamp: {
          ...state.lastFeedRefreshTimestamp,
          [`${component}`]: null,
        },
      };
    }
    case SET_REFRESH_DURATION: {
      const { feedStaleDelayMs } = action.payload;
      return {
        ...state,
        feedStaleDelayMs,
      };
    }
    case SILENT_REFRESH: {
      const { lastFeedRefreshTimestamp } = state;

      if (lastFeedRefreshTimestamp) {
        const lastFeedRefreshTimestampCopy = { ...lastFeedRefreshTimestamp };
        const screens = Object.keys(lastFeedRefreshTimestampCopy);
        screens.forEach((sc) => {
          if (lastFeedRefreshTimestampCopy[sc] != null) {
            lastFeedRefreshTimestampCopy[sc] = new Date(0);
          }
        });
        return {
          ...state,
          lastFeedRefreshTimestamp: {
            ...lastFeedRefreshTimestampCopy,
          },
        };
      }
      return state;
    }
    default:
      return state;
  }
};
reducer.initialState = initialState;
export default reducer;
